// extracted by mini-css-extract-plugin
var _1 = "TabBarMenu-module__animateUploadProgressBarWidth--T5Mua";
var _2 = "TabBarMenu-module__animatedBackground--KM_ZY";
var _3 = "TabBarMenu-module__avatarIcon--UeRX2";
var _4 = "TabBarMenu-module__cloud--d4Fph";
var _5 = "TabBarMenu-module__container--eCYG0";
var _6 = "TabBarMenu-module__entityIcon--xSMEQ";
var _7 = "TabBarMenu-module__home--_Vll0";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatarIcon", _4 as "cloud", _5 as "container", _6 as "entityIcon", _7 as "home" }
